import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-forest text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="mb-5">
            <span className="inline-block bg-ivory rounded-sm px-4 py-3">
              <img src="/logo-emblem.png" alt="Mount Moriah Relief logo" className="h-16 w-auto" />
            </span>
          </div>
          <p className="text-sm text-white/75 leading-relaxed">
            Bringing Hope. Relieving Hardship. Restoring Dignity.
          </p>
          <p className="text-sm text-white/75 leading-relaxed mt-4">
            A charitable organisation established in Northern Ireland in 2024, working to prevent
            and relieve poverty, hardship and suffering.
          </p>
        </div>
        <nav aria-label="Footer — organisation">
          <h2 className="text-xs tracking-widest uppercase font-semibold text-gold mb-5">Organisation</h2>
          <ul className="space-y-3 text-sm">
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/about">About Us</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/trustees">Trustees</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/governance">Governance &amp; Transparency</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/our-impact">Our Impact</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/news">News &amp; Stories</Link></li>
          </ul>
        </nav>
        <nav aria-label="Footer — take action">
          <h2 className="text-xs tracking-widest uppercase font-semibold text-gold mb-5">Take Action</h2>
          <ul className="space-y-3 text-sm">
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/donate">Donate</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/get-involved">Get Involved</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/our-work">Our Work</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/zimbabwe">Zimbabwe</Link></li>
            <li><Link className="text-white/80 hover:text-white transition-colors duration-300" to="/contact">Contact</Link></li>
          </ul>
        </nav>
        <div>
          <h2 className="text-xs tracking-widest uppercase font-semibold text-gold mb-5">Contact &amp; Policies</h2>
          <a
            href="mailto:admin@mountmoriahrelief.org"
            className="flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors duration-300 mb-5"
            data-testid="footer-email-link"
          >
            <Mail size={15} aria-hidden="true" /> admin@mountmoriahrelief.org
          </a>
          <ul className="space-y-3 text-sm">
            <li><Link className="text-white/70 hover:text-white transition-colors duration-300" to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link className="text-white/70 hover:text-white transition-colors duration-300" to="/cookie-policy">Cookie Policy</Link></li>
            <li><Link className="text-white/70 hover:text-white transition-colors duration-300" to="/safeguarding">Safeguarding</Link></li>
            <li><Link className="text-white/70 hover:text-white transition-colors duration-300" to="/complaints">Complaints Procedure</Link></li>
            <li><Link className="text-white/70 hover:text-white transition-colors duration-300" to="/accessibility">Accessibility Statement</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
          <p className="text-xs text-white/60">
            &copy; {new Date().getFullYear()} Mount Moriah Relief. All rights reserved.
          </p>
          <p className="text-xs text-white/60" data-testid="footer-charity-status">
            Charity registration details will be published here once formally confirmed.
          </p>
        </div>
      </div>
    </footer>
  );
}
